import { addNumberSeparator } from '@va/util/helpers';
import { useLocale } from '@va/localization';
import classNames from 'classnames';
import { isNil } from 'lodash';
import { Paragraph } from '../../typography';

type ChartProgressBarTypes = {
  color: string;
  percentage: number;
  className?: string;
  total?: number;
};

export const ChartProgressBar = ({ percentage, className, color, total }: ChartProgressBarTypes) => {
  const { locale } = useLocale();

  return (
    <div className={classNames('flex items-center gap-1', className)}>
      <div
        style={{
          width: `${percentage}%`,
          backgroundColor: `${color}`,
        }}
        className='min-w-3 h-3 rounded-10px'
      />
      {!isNil(total) && <Paragraph className='ml-3 font-525!'>{addNumberSeparator(total, locale)}</Paragraph>}
    </div>
  );
};
